// import { CallAPI } from "./apiActions";
// import { setCache, getInFlight, setInFlight, clearInFlight } from "./apiCache";

// export function silentRevalidate({ cacheKey, callArgs, ttl }) {
//   if (getInFlight(cacheKey)) return getInFlight(cacheKey);

//   const promise = CallAPI(...callArgs)
//     .then((res) => {
//       if (res) {
//         setCache(cacheKey, {
//           data: res,
//           timestamp: Date.now(),
//           ttl,
//         });
//       }
//       return res;
//     })
//     .finally(() => clearInFlight(cacheKey));

//   setInFlight(cacheKey, promise);
//   return promise;
// }

// revalidate.js
import { CallAPI } from "./apiActions";
import { setCache, getInFlight, setInFlight, clearInFlight } from "./apiCache";

export function silentRevalidate({ cacheKey, callArgs, ttl }) {
  const inFlight = getInFlight(cacheKey);
  if (inFlight) return inFlight;

  const promise = CallAPI(...callArgs)
    .then((res) => {
      if (res) {
        setCache(cacheKey, {
          data: res,
          timestamp: Date.now(),
          ttl,
        });
      }
      return res;
    })
    .finally(() => clearInFlight(cacheKey));

  setInFlight(cacheKey, promise);
  return promise;
}
